import React, { useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../context/authConfig";
import Navbar from 'react-bootstrap/Navbar';
import { NavLink } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faList, faBars, faListAlt,faUserPlus, faCircleCheck} from '@fortawesome/free-solid-svg-icons';
import '../styles/pageLayout.css';
import logo from '../assets/Nigerian-Coat-of-Arms.png';
import logout from '../assets/logout.png';
import { Box } from '@mui/material';
import { Avatar, Menu, MenuItem, Typography, ListItemText } from '@mui/material';
import { useMediaQuery } from 'react-responsive';


export const PageLayout = ({userRole ,children}) => {
    const isAuthenticated = useIsAuthenticated();
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [profileAnchorEl, setProfileAnchorEl] = useState(null);
    const openProfileMenu = Boolean(profileAnchorEl);;

    const { instance, accounts } = useMsal();
    const isMobile = useMediaQuery({ maxWidth: 768 });
    React.useEffect(() => {
  // Always collapse by default on mobile
  if (isMobile) {
    setIsCollapsed(true);
  }
}, [isMobile]);

   const toggleSidebar = () => {
  if (isMobile) {
    // Toggle expanded/collapsed for mobile
    setIsCollapsed(prev => !prev);
  } else {
    setIsCollapsed(prev => !prev); // Allow toggle manually on desktop too if desired
  }
};


    const handleLogout = (logoutType) => {
        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    };

    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest).catch(console.log);
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(console.log);
        }
    };

    const getInitials = (name) => {
        const parts = name.split(' ');
        console.log(parts);
        if (parts.length === 1) {
            return parts[0].charAt(0).toUpperCase();
        }
        return parts.slice(0, 2).map(part => part.charAt(0).toUpperCase()).join('');
    };

    const getFirstName = (name) => {
        const parts = name.split(' ');
        const firstName = parts[0] ? parts[0] : "";
        const lastName = parts[1] ? parts[1] : "";
        return firstName + " " + lastName;  
    };

    const handleProfileClick = (event) => {
    setProfileAnchorEl(event.currentTarget);
};

const handleProfileClose = () => {
    setProfileAnchorEl(null);
};
    return (
        <div className="page-layout">
            {/* Top Navbar */}
            <Navbar bg="dark" variant="dark" className="top-nav">
                <Navbar.Brand href="/" className="navbar-logo">
                    <img src={logo} alt="NCMS Logo" width="50" />
                    <span className="companyText">NCMS</span>
                    <span className="logoText">e-Affidavit</span>
                </Navbar.Brand>
                <div className="navbar-right">
                    {isAuthenticated ? (
                        <>
                        <div>
                            
                        </div>
                            <h5 className="initials" onClick={handleProfileClick} style={{ cursor: 'pointer' }}>
                                {getInitials(accounts[0].name)}</h5>

                            <h5 className="user-name" onClick={handleProfileClick}  style={{ cursor: 'pointer' }} >{getFirstName(accounts[0].name)} </h5>

                            <Box display="flex" alignItems="center" sx={{ cursor: 'pointer' }} onClick={() => handleLogout("redirect")}>
                                <img
                                    src={logout}
                                    alt="logout Logo"
                                    width="40"
                                    className="logout-img"
                                    style={{ marginleft: '2px',marginRight:'5px',marginBottom:'10px'}}
                                />
                                
                                <div className="logout">
                                <span style={{color:'#fff',fontWeight: 'bold',marginLeft:'5px'}}>Logout</span>
                                </div>
                            </Box>
                        </>
                    ) : (
                        <img
                            src={logout}
                            alt="login Logo"
                            width="40"
                            onClick={() => handleLogin("redirect")}
                            name="Sign in"
                        />
                    )}
                </div>
            </Navbar>

            {/* Page Content Layout */}
            <div className="page-container">
                {/* Side Navigation */}
                <div className={`sidenav ${isCollapsed ? 'collapsed' : ''}`}>
                    <div className="collapse-toggle" onClick={toggleSidebar}>
                        <FontAwesomeIcon icon={faBars} />
                    </div>
                    <div className="nav-items">
                    {userRole === "user" && (
                    <>
                        <NavLink
                            to="/apply-affidavit"
                            className={({ isActive }) => `sidenav-item ${isActive ? 'active' : ''}`}
                        >
                            <FontAwesomeIcon icon={faUserPlus} style={{ marginRight: '10px' }} />
                            {!isCollapsed && <span className="nav-text">Apply for Affidavit</span>}
                        </NavLink>
                        <NavLink
                            to="/request-list"
                            className={({ isActive }) => `sidenav-item ${isActive ? 'active' : ''}`}
                        >
                            <FontAwesomeIcon icon={faList} style={{ marginRight: '10px' }} />
                            {!isCollapsed && <span className="nav-text">My Requests List</span>}
                        </NavLink>
                        <NavLink
                            to="/signed-request-list"
                            className={({ isActive }) => `sidenav-item ${isActive ? 'active' : ''}`}
                        >
                            <FontAwesomeIcon icon={faCircleCheck} style={{ marginRight: '10px' }} />
                            {!isCollapsed && <span className="nav-text">Signed Requests</span>}
                        </NavLink>
                        </>
                )}
                {userRole === "superadmin" && (
                    <>
                        <NavLink
                            to="/search-request"
                            className={({ isActive }) => `sidenav-item ${isActive ? 'active' : ''}`}
                        >
                            <FontAwesomeIcon icon={faFileAlt} style={{ marginRight: '10px' }} />
                            {!isCollapsed && 'Affidavit Search'}
                        </NavLink>
                       
                        <NavLink
                            to="/admin/request-list"
                            className={({ isActive }) => `sidenav-item ${isActive ? 'active' : ''}`}
                        >
                            <FontAwesomeIcon icon={faList} style={{ marginRight: '10px' }} />
                            {!isCollapsed && 'All Requests'}
                        </NavLink>
                          </>
                        )}
                    </div>
                </div>
                    <Menu anchorEl={profileAnchorEl} open={openProfileMenu} onClose={handleProfileClose} onClick={handleProfileClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }} PaperProps={{sx: {
      backgroundColor: 'white',color: 'black !important','& a': {textDecoration: 'underline',
      },
    },
  }}
>
                        <MenuItem disableRippled  sx={{cursor: 'default',opacity: 1, color: 'black'}}>
                            <Box display="flex" flexDirection="column">
                                <Typography variant="subtitle1" fontWeight="bold" sx={{ color: 'black', fontSize: '1rem', lineHeight: 1.2 }}>
                                    {accounts[0].name}
                                </Typography>
                                <Typography variant="body2" sx={{fontSize:'12px'}}>{accounts[0].username}</Typography>
                            </Box>
                        </MenuItem>
                        {userRole !== "user" && (
                        <MenuItem>
                            <ListItemText
                            primary={
                                <Typography
                                component="a"
                                href="/manage-signature"
                                sx={{ textDecoration: 'none', color: 'green !important', fontSize: '14px' }}
                                >
                                Manage Signature
                                </Typography>
                            }
                            />
                        </MenuItem>
)}

                    </Menu>

                {/* Main Content */}
                <div className="main-content">
                    {children}
                </div>
            </div>
            <div className='divider'></div>
            <div className='footer'>
                    <p>
                    Copyrights © 2025 National Judicial Council. All Rights Reserved.
                    </p>
                </div>
        </div>
    );
};